import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getArticles } from '@/lib/api';
import type { BlogArticle } from '@/lib/types';

export default function BlogPreview() {
  const [posts, setPosts] = useState<BlogArticle[]>([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const data = await getArticles();

        if (data) {
          setPosts(data.slice(0, 4));
        }
      } catch (error) {
        console.error("Error al cargar artículos:", error);
      }
    };

  fetchPosts();
}, []);

  return (
    <section className="py-20 bg-[#c9b8f0]/15">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-0 rounded-3xl overflow-hidden">
          {/* Left Panel */}
          <div className="lg:w-2/5 bg-gradient-to-br from-[#00b4c8] to-[#c9b8f0] p-10 md:p-14 flex flex-col justify-center">
            <span className="text-xs font-semibold text-white/70 uppercase tracking-widest mb-4">
              Blog
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-white leading-tight mb-5"
            >
              Inspiración Dulce
            </h2>
            <p className="text-white/80 text-base leading-relaxed mb-8">
              Descubre recetas, consejos y las historias detrás de nuestras creaciones artesanales. Cada publicación es un pedacito de nuestra alma.
            </p>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 bg-white text-[#00b4c8] font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#e0f7fa] transition-colors cursor-pointer whitespace-nowrap self-start"
            >
              Leer Más <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right Grid */}
          <div className="lg:w-3/5 grid grid-cols-2 gap-0">
            {posts.map((post, i) => (
              <Link
                key={post.id}
                to="/blog"
                className="group relative overflow-hidden cursor-pointer block"
                style={{ aspectRatio: '1/1' }}
              >
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-xs text-[#fde68a] font-semibold uppercase tracking-wider">
                    {post.category}
                  </span>
                  <p className="text-white font-semibold text-sm mt-1 leading-tight line-clamp-2">
                    {post.title}
                  </p>
                  <p className="text-white/60 text-xs mt-1">{post.date}</p>
                </div>
                {i === 0 && (
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#fde68a] text-[#2d1a0e] text-xs font-bold px-2.5 py-1 rounded-full">
                      Destacado
                    </span>
                  </div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
